var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeart33(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "25px",
    viewBox: "0 0 32 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enter-Competition-btn",
    transform: "translate(-334.000000, -777.000000)",
    fillRule: "nonzero",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 767.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.474857,13.6714074 C351.231996,12.8723704 352.134239,12.2036667 353.135077,11.7368519 C354.136846,11.2674815 355.23814,11 356.393382,11 C357.548625,11 358.649919,11.2146667 359.651688,11.6022593 C360.653456,11.9907037 361.554768,12.5520741 362.311908,13.2454815 C363.068118,13.9388889 363.682945,14.7651852 364.106162,15.6826296 C364.531239,16.5992222 364.764706,17.6086667 364.764706,18.6666667 C364.764706,19.7246667 364.530309,20.7341111 364.106162,21.6507037 C363.682945,22.5681481 363.069978,23.3944444 362.311908,24.0878519 C361.555699,24.7812593 350.884121,33.6115556 349.882353,34 C348.880585,33.6115556 338.209007,24.7812593 337.451868,24.0878519 C336.694728,23.3944444 336.081761,22.5681481 335.657614,21.6507037 C335.234397,20.7341111 335,19.7246667 335,18.6666667 C335,17.6086667 335.234397,16.5992222 335.657614,15.6826296 C336.081761,14.7651852 336.693798,13.9388889 337.451868,13.2454815 C338.209007,12.5520741 339.11125,11.9907037 340.113018,11.6022593 C341.113857,11.2146667 342.215151,11 343.371324,11 C344.527496,11 345.62879,11.2674815 346.629629,11.7351481 C347.631397,12.2036667 348.401542,12.667368 349.159612,13.466405 C349.916751,14.2662939 349.716787,14.4712963 350.474857,13.6714074 Z",
    id: "heart"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeart33);
export default __webpack_public_path__ + "static/media/icHeart33.95a9d78d99a5ffabfd6484afe310681e.svg";
export { ForwardRef as ReactComponent };